import React from 'react'

const LoginCount = (props) => {

    return (
        <div>
            <span>{props.count}</span>
        </div>
    )
}

export default LoginCount